import { apiGet, apiToken } from "./requests";

export const getPrinters = () => {
    let path = "printers/";
    return apiGet(path);
};

export const createPrinter = (data) => {
    let path = "printers/";
    return apiToken(data, path, "post");
};

export const updatePrinter = (printerId, data) => {
    let path = `printer/${printerId}`;
    return apiToken(data, path, "patch");
};

export const deletePrinter = (printerId) => {
    let path = `printer/${printerId}`;
    return apiToken({}, path, "delete");
};